import { AnalyticsTrackData } from 'models/Analytics';
import { Article, Shipment } from 'models/shipments';
import { fallbackMilestoneParams, getFutureMilestones, getMilestone } from 'utils/milestone.utils';

export function transformShipmentToAnalytics(
  shipment: Shipment | null,
  article: Article | null,
  dialogCard?: string | null
): Partial<AnalyticsTrackData> {
  const analyticsTrackData: Partial<AnalyticsTrackData> = {
    dialogCard: dialogCard ?? 'null',
    dynamicComms: '', // TODO populate this
    id: article?.articleId || 'null',
    addressType: article?.address?.addressType as string,
    atl: article?.atlEligible ? 'atl available' : 'atl unavailable',
    delegate: article?.collectionInstruction?.delegate?.allowed ? 'eligible' : 'ineligible',
    latestEvent: article?.events?.[0]?.eventCode || 'null',
    milestone: getMilestone(article as fallbackMilestoneParams),
    redirect: article?.redirectStatus || 'null',
    productSubType: article?.productSubType ?? 'null',
  };

  if (analyticsTrackData.milestone) {
    const futureMilestones = getFutureMilestones(analyticsTrackData.milestone, analyticsTrackData.addressType);
    analyticsTrackData.futureMilestone = futureMilestones?.[0] || 'no future milestone';
  }

  const firstArticle = shipment?.articles[0];
  analyticsTrackData.hasNickname = firstArticle?.nickname || 'null';

  analyticsTrackData.merchantBranded = shipment?.merchant?.logoUrl ? 'yes' : 'no';
  return analyticsTrackData;
}
